// Brand assets and static content for Kung Fu TCG
export const LOGOS = {
  mascot:
    "https://customer-assets.emergentagent.com/job_0e836073-09c0-47fe-b0d3-e6834d50289d/artifacts/fc3h07os_ChatGPT%20Image%20May%2028%2C%202026%20at%2004_07_18%20PM.png",
  mascotFull: "/mascot-full.png",
  wordmark: "/wordmark.png",
};

export const BG = {
  heroTexture:
    "https://static.prod-images.emergentagent.com/jobs/0e836073-09c0-47fe-b0d3-e6834d50289d/images/fa718ef9e38550ac715b7f3243107eb5e1d296741f09ca509637df585534933e.png",
  bobaLifestyle:
    "https://images.pexels.com/photos/15487855/pexels-photo-15487855.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  tcgLifestyle:
    "https://images.unsplash.com/photo-1614096602618-38a342f139c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHx0cmFkaW5nJTIwY2FyZCUyMGdhbWUlMjBwbGF5aW5nfGVufDB8fHx8MTc4MDAwMzA1NHww&ixlib=rb-4.1.0&q=85",
  bobaHero:
    "https://static.prod-images.emergentagent.com/jobs/0e836073-09c0-47fe-b0d3-e6834d50289d/images/7e12586babe37c92fc6802aac3aab1b1b2832ea8f99e813981c4676400341171.png",
};

export const CATEGORIES = [
  { id: "tcg", label: "TCG" },
  { id: "board-games", label: "Board Games" },
  { id: "accessories", label: "Accessories" },
];

export const HOURS = [
  { day: "Mon – Thu", hours: "11:00 AM – 9:00 PM" },
  { day: "Fri – Sun", hours: "11:00 AM – 9:30 PM" },
];

export const LOCATION = {
  name: "Kung Fu Tea",
  address: "160 FM-544 Suite 90",
  city: "Murphy, TX 75094",
  phone: "(469) 298-0981",
  email: "bobaboysllc@gmail.com",
};

export const BOBA_MENU = [
  { name: "Kung Fu Milk Tea", price: "$6.50", desc: "Our signature black milk tea, brown sugar boba." },
  { name: "Mango Snow", price: "$6.50", desc: "Fresh mango blended with snow ice and pearls." },
  { name: "Taro Milk Tea", price: "$6.50", desc: "Roasted taro, creamy milk tea, classic boba." },
  { name: "Oreo Cream Wow", price: "$6.50", desc: "Oreo blended cream with whipped topping and boba." },
];

export const EVENTS = [
  "FRI · One Piece TCG Locals · 7PM",
  "SAT · Pokémon Standard Tournament · 1PM",
  "SUN · Board Game Night · 5PM",
  "TUE · MTG Commander · 6:30PM",
  "WED · Yu-Gi-Oh! Sealed · 7PM",
  "THU · Learn-to-Play Sessions · 6PM",
];
